import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { CcpaApiClient, ccpaApiRef } from './api';

export const ccpaPlugin = createPlugin({
  id: 'ccpa',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: ccpaApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new CcpaApiClient({ discoveryApi, identityApi }),
    }),
  ],
});

export const CcpaPage = ccpaPlugin.provide(
  createRoutableExtension({
    name: 'CcpaPage',
    component: () =>
      import('./components/MainComponent').then(m => m.MainComponent),
    mountPoint: rootRouteRef,
  }),
);
